import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { IconProps } from '@models/icons';
import type { RegisteredActivityName } from '@stackflow/config';
import { useFlow } from '@stackflow/react';
import { openExternalLink } from '@utils/nativeUtils';
import { JSX } from 'react';

interface Props {
    icon?: (props:IconProps) => JSX.Element;
    label: string;
    externalLink?: string;
    activityName?: RegisteredActivityName;
    activityParams?: object;
}

function LinkRow({
    icon: IconComponent, label, activityParams, activityName, externalLink,
}:Props) {
    if (activityName && !activityParams) {
        throw new Error('activityParams is required when activityName is provided');
    }
    const { push } = useFlow();
    const handleClick = () => {
        if (activityName) {
            push(activityName, activityParams!);
        } else if (externalLink) {
            openExternalLink(externalLink);
        }
    };
    return (
        <Container justify='space-between'
            onClick={handleClick}
            fullWidth
            align='center'>
            <Row spacing={6}>
                {IconComponent && (
                    <IconComponent color={colors.gray5}
                        size={24} />)}
                <Text color={colors.gray9} size='lg'>{label}</Text>
            </Row>
        </Container>
    );
}

const Container = styled(Row)`
    cursor: pointer;
    padding: 8px 0;
    width: 100%;
`;

export default LinkRow;
